import PropTypes from 'prop-types'
import React, { Component } from 'react'
import PrintR from 'components/PrintR'
import _LoadingStripes from 'components/Loading/_styles/_LoadingStripes'
import { withTranslation } from 'react-i18next'

/*
в папке  _styles есть старый спинер
 */
@withTranslation()
export default class Loading extends Component {

  render () {
    const { t, i18n, tReady, error, ...rest } = this.props
    if (error) {
      return (
        <PrintR {...{
          title: t('Error loading component'),
          object: error
        }} />
      )
    }

    return <_LoadingStripes {...rest} />
  }

  static propTypes = {
    slim: PropTypes.bool
  }

}
